{
  "slug": "what-is-an-iq-test",
  "title": "What Is an IQ Test?",
  "description": "Learn what an IQ test is, which abilities it samples, how scores are standardized, and what the result cannot tell you.",
  "summary": "An IQ test is a structured set of cognitive tasks interpreted against an age-based reference group. Its result is an estimate of selected abilities, not a complete measure of a person.",
  "category": "IQ essentials",
  "sections": [
    {
      "heading": "What the test is designed to do",
      "paragraphs": [
        "An intelligence test samples performance on tasks chosen to represent abilities such as reasoning, working memory, verbal comprehension, visual-spatial processing, or processing speed. Different instruments combine those abilities in different ways.",
        "Raw answers become useful only after comparison with a suitable norm group. Many modern IQ scales are centered on 100, but the meaning of a score depends on the instrument, norms, administration, and purpose."
      ]
    },
    {
      "heading": "Professional and online formats",
      "paragraphs": [
        "A professional assessment uses a standardized instrument, controlled instructions, trained administration, and an interpretive report. An online IQ-style test can offer practice or an indicative estimate but normally cannot reproduce the same controls.",
        "A polished interface does not establish validity. Look for transparent scoring, suitable norms, reliability evidence, accessibility information, and an honest explanation of limitations."
      ]
    },
    {
      "heading": "What the result does not measure",
      "paragraphs": [
        "IQ tests do not fully measure creativity, curiosity, wisdom, motivation, emotional skill, practical judgment, character, or specialist expertise. Performance can also be affected by language, health, fatigue, anxiety, device, and testing conditions.",
        "Use an online result for reflection rather than diagnosis, admission, employment, or educational placement. Decisions with consequences require evidence appropriate to that specific use."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Is an IQ test the same as an intelligence assessment?",
      "answer": "The terms overlap, but a professional assessment usually includes controlled administration, multiple scores, context, and qualified interpretation."
    },
    {
      "question": "Does every IQ test measure the same abilities?",
      "answer": "No. Instruments differ in tasks, domains, norms, score scales, age ranges, and intended uses."
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "is-an-online-iq-test-accurate"],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — intelligence test",
      "url": "https://dictionary.apa.org/intelligence-test"
    },
    {
      "label": "Standards for Educational and Psychological Testing",
      "url": "https://www.testingstandards.net/"
    }
  ]
}
